module.exports = __webpack_public_path__ + "b26caa67387d31181fbb08ae8ae9b75d.svg";